import styled from 'styled-components';

export const BlockChainDisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const BlockWithChevron = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
